import React from "react";
import ROILineChart from "./ROILineChart";
import ROIBarChart from "./ROIBarChart";
import {IDailyData} from "../models/roi-widget.state";

interface IROIChartContainerProps {
    currentData: IDailyData[];
    previousData?: IDailyData[];
    chartType: "line" | "bar";
    metric: "count" | "timeSaved" | "costSaved";
    currency?: string;
    showComparison?: boolean;
    height?: number;
}

const ROIChartContainer: React.FC<IROIChartContainerProps> = ({
    currentData,
    previousData,
    chartType,
    metric,
    currency = "USD",
    showComparison = false,
    height = 300,
}) => {
    // Return empty state if no data
    if (!currentData || currentData.length === 0) {
        return (
            <div className="roi-widget__chart-empty">
                <div className="roi-widget__empty-message">
                    <i className="g-icon g-icon-chart-analytics"></i>
                    <p>No chart data available for the selected period</p>
                </div>
            </div>
        );
    }

    // Render appropriate chart based on type
    if (chartType === "line") {
        return (
            <ROILineChart
                currentData={currentData}
                previousData={previousData}
                metric={metric}
                currency={currency}
                showComparison={showComparison}
                height={height}
            />
        );
    }

    return (
        <ROIBarChart
            currentData={currentData}
            previousData={previousData}
            metric={metric}
            currency={currency}
            showComparison={showComparison}
            height={height}
        />
    );
};

export default ROIChartContainer;
